import React from "react";
import styles from "./Page01.module.scss";
import { useBlocks } from "@jelly/lesson";
import classnames from "classnames";
import { useUi } from "@jelly/lesson";

type singleSoundData = {
  url: string;
  saxophone: string;
  guitar: string;
  bass: string;
};
type sampleIndexes =
  | "13"
  | "23"
  | "33"
  | "43"
  | "53"
  | "12"
  | "22"
  | "32"
  | "42"
  | "52"
  | "11"
  | "21"
  | "31"
  | "41"
  | "51";

interface Lesson0301Page01Props {
  dataBoxIntro: string;
  saxName: string;
  guitarName: string;
  doubleBassName: string;
  samples: Record<sampleIndexes, singleSoundData>;
}

export const Lesson0301Page01: React.FC<Lesson0301Page01Props> = (props) => {
  const block = useBlocks();
  const { Pill } = useUi();

  const [autoplay, setAutoplay] = React.useState(false);
  const [sampleId, setSampleId] = React.useState<string | null>(null);
  const [fileUrl, setFileUrl] = React.useState<string>(``);
  const [saxValue, setSaxValue] = React.useState<string>(`- ms`);
  const [guitarValue, setGuitarValue] = React.useState<string>(`- ms`);
  const [bassValue, setbassValue] = React.useState<string>(`- ms`);

  const toggleSampleId = (id: sampleIndexes): void => {
    if (id === sampleId) {
      setAutoplay(false);
      setbassValue("- ms");
      setGuitarValue("- ms");
      setSaxValue("- ms");
      setSampleId(null);
    } else {
      setSampleId(id.toString());
      setbassValue(props.samples[id].bass);
      setGuitarValue(props.samples[id].guitar);
      setSaxValue(props.samples[id].saxophone);
      setFileUrl(props.samples[id].url);
      setAutoplay(true);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.soundMapWrapper}>
        <div className={styles.soundMap}>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "13" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("13");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "23" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("23");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "33" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("33");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "43" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("43");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "53" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("53");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "12" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("12");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "22" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("22");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "32" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("32");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "42" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("42");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "52" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("52");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "11" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("11");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "21" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("21");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "31" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("31");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "41" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("41");
            }}
          ></div>
          <div
            className={classnames(styles.soundMapItem, [sampleId == "51" ? styles.active : ""])}
            onClick={() => {
              toggleSampleId("51");
            }}
          ></div>
        </div>
      </div>
      <div className={styles.dataWrapper}>
        <p>{props.dataBoxIntro}</p>
        <div className={styles.dataTable}>
          <div className={styles.dataTableRow}>
            <div className={styles.dataTableLabelCol}>{props.saxName}:</div>

            <div className={styles.dataTableValueCol}>
              <Pill theme="secondary">{saxValue}</Pill>
            </div>
          </div>
          <div className={styles.dataTableRow}>
            <div className={styles.dataTableLabelCol}>{props.guitarName}:</div>
            <div className={styles.dataTableValueCol}>
              <Pill theme="primary">{guitarValue}</Pill>
            </div>
          </div>
          <div className={styles.dataTableRow}>
            <div className={styles.dataTableLabelCol}>{props.doubleBassName}:</div>
            <div className={styles.dataTableValueCol}>
              <Pill theme="success">{bassValue}</Pill>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.playerWrapper}>
        {autoplay && (
          <block.audio src={fileUrl} key={`sample_${sampleId}`} autoplay={autoplay} styles={{ display: "none" }} />
        )}
      </div>
    </div>
  );
};
